module.exports = __webpack_public_path__ + "img/2-3.11406883.png";